import {FullScreenAdEvents} from '@gamezop/ads-sdk/types'
import {
  triggerAdFailedEvent,
  triggerAdLoadedEvent,
  triggerAdViewedEvent,
  triggerAdRequestedEvent,
  triggerAdDismissedEvent,
  triggerAdDelayedEvent,
  triggerAdClosedEvent,
} from './events'

export const handleFullScreenAds = (
  cb: FullScreenAdEvents,
  adSpot: string,
  adDemand: string,
  isGameplayerPage?: boolean,
  gameCode?: string,
  gameName?: string,
) => {
  if (cb === FullScreenAdEvents.ALL_ADS_FAILED) {
    console.log('cb: ', 'all ads failed')
  }

  if (cb === FullScreenAdEvents.AD_FAILED) {
    triggerAdFailedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }

  if (cb === FullScreenAdEvents.AD_SUCCESS) {
    triggerAdLoadedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }

  if (cb === FullScreenAdEvents.AD_VIEWED) {
    triggerAdViewedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }

  if (cb === FullScreenAdEvents.AD_REQUESTED) {
    triggerAdRequestedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }

  if (cb === FullScreenAdEvents.AD_DISMISSED) {
    triggerAdDismissedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }

  if (cb === FullScreenAdEvents.AD_DELAYED) {
    triggerAdDelayedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }
  if (cb === FullScreenAdEvents.AD_CLOSED) {
    triggerAdClosedEvent(adSpot, adDemand, '', isGameplayerPage, gameName, gameCode)
  }
}
